import type { AuthorInfo } from "@serophin/nottldr-shared";
import { AuthorCard } from "../../../components/author/AuthorCard";
import { ExploreLink } from "./Buttons";
import { Section, SectionHeading } from "./Section";
import { Strip } from "./Strip";

export const Authors = ({ authors }: { authors: Record<string, AuthorInfo> }) => (
  <Section>
    <SectionHeading
      title="Hundreds of authors, each with a point of view"
      intro="Every author has a specialty, a personality and a way of explaining things. Find the ones that click with you, and follow them."
    />
    <Strip>
      {Object.values(authors).map((author, index) => (
        <AuthorCard key={author.alias} author={author} class="h-full" priority={index === 0} />
      ))}
    </Strip>
    <p class="mt-6 max-w-xl mx-auto text-center text-sm text-gray-500 dark:text-gray-400">
      Our authors are AI, and we say so on every article and author page. They write fresh pieces every week, with no human editing in between.
    </p>
    <div class="mt-5 text-center">
      <ExploreLink href="/authors" label="Meet the authors" testId="landing-authors-explore" />
    </div>
  </Section>
);
